export const SHORTLIST_CHECKBOX_SIZE = 26;
